import { Box } from '../../../../common/ui/Box';
import { useOfferSuggestionsStream } from '../../../create-enquiry/hooks/useOfferSuggestionsStream';
import { OfferApprovalSection } from '../../components/intelligence/OfferApprovalSection';
import { OfferReviewDrawerContent } from '../../components/intelligence/OfferReviewDrawerContent';

interface OfferReviewDrawerProps {
    orderId: string;
    onRequestApproval: (selectedApproverEmails: string[], message?: string, selectedOfferId?: string) => Promise<void>;
}

export const OfferReviewDrawer = ({ orderId, onRequestApproval }: OfferReviewDrawerProps) => {
    const streamQuery = useOfferSuggestionsStream(orderId);

    return (
        <Box
            display="grid"
            gridTemplateRows="minmax(0, 1fr) auto"
            height="100%"
            minHeight={0}
            gridTemplateColumns="100%"
        >
            <OfferReviewDrawerContent orderId={orderId} />

            {streamQuery.finalResult?.success && streamQuery.finalResult.selectedOfferId ? (
                <OfferApprovalSection
                    selectedOfferId={streamQuery.finalResult.selectedOfferId}
                    onRequestApproval={onRequestApproval}
                    message={streamQuery.finalResult.message}
                />
            ) : null}
        </Box>
    );
};
